import type { IntlShape } from 'react-intl';
import { messages } from './messages';

export interface AccordionSchema {
  title: string;
  fieldsets: { id: string; title: string; fields: string[] }[];
  properties: Record<string, unknown>;
  required: string[];
}

export const FAQ_FIELD = 'faq';

export const accordionFaqSchemaEnhancer = ({
  schema,
  intl,
}: {
  schema: AccordionSchema;
  intl: IntlShape;
}): AccordionSchema => {
  schema.properties[FAQ_FIELD] = {
    title: intl.formatMessage(messages.Faq),
    description: intl.formatMessage(messages.FaqHelp),
    widgetOptions: {
      frontendOptions: {
        widget: 'checkbox',
      },
    },
  };

  const options = schema.fieldsets.find((set) => set.id === 'options');

  if (options) {
    options.fields = [FAQ_FIELD];
    return schema;
  }

  const fallback = schema.fieldsets[schema.fieldsets.length - 1];

  if (fallback && !fallback.fields.includes(FAQ_FIELD)) {
    fallback.fields.push(FAQ_FIELD);
  }

  return schema;
};
